import React from 'react';
import CustomSpinner from 'modules/ui/mobile/CustomSpinner.component';
import { View } from 'react-native';
import { BodyText, Box } from 'modules/styled';
import { useRelatedUsers } from '../hooks';
import { useSelector } from 'react-redux';
import { renderRow, renderHeader } from '../related.common';

export const RelatedUsers = (): JSX.Element => {
  const modalData = useSelector((state: any) => state?.navigation?.modalData);
  const { data, loading } = useRelatedUsers(modalData.userId);

  const body = data?.relatedUsers.length ? (
    data?.relatedUsers.map(renderRow)
  ) : loading ? (
    <Box sx={{ p: 3 }}>
      <CustomSpinner />
    </Box>
  ) : (
    <BodyText sx={{ fontSize: 5, lineHeight: 5, textAlign: 'center' }}>
      No related accounts.
    </BodyText>
  );

  return (
    <View style={{ flex: 1 }}>
      <Box sx={{ paddingY: 2 }}>{renderHeader()}</Box>
      {body}
    </View>
  );
};

export default RelatedUsers;
